import { Provider } from "@angular/core";
import { PreguntaExportadorToken } from "@shared/tokens";
import { PreguntaDateSelectExportador } from "./preguntas/PreguntaDateSelectExportador";
import { PreguntaDistributionExportador } from "./preguntas/PreguntaDistributionExportador";
import { PreguntaExtraPointsExportador } from "./preguntas/PreguntaExtraPointsExportador";
import { PreguntaFlowCheckpointExportador } from "./preguntas/PreguntaFlowCheckpointExportador";
import { PreguntaFlowGroupExportador } from "./preguntas/PreguntaFlowGroupExportador";
import { PreguntaFlowJumpExportador } from "./preguntas/PreguntaFlowJumpExportador";
import { PreguntaFlowRandomExportador } from "./preguntas/PreguntaFlowRandomExportador";
import { PreguntaInfoExportador } from "./preguntas/PreguntaInfoExportador";
import { PreguntaMatrixMultipleExportador } from "./preguntas/PreguntaMatrixMultipleExportador";
import { PreguntaMatrixRangeExportador } from "./preguntas/PreguntaMatrixRangeExportador";
import { PreguntaMatrixSingleExportador } from "./preguntas/PreguntaMatrixSingleExportador";
import { PreguntaMultipleExportador } from "./preguntas/PreguntaMultipleExportador";
import { PreguntaNumericTextExportador } from "./preguntas/PreguntaNumericTextExportador";
import { PreguntaRangeExportador } from "./preguntas/PreguntaRangeExportador";
import { PreguntaRankingExportador } from "./preguntas/PreguntaRankingExportador";
import { PreguntaSingleExportador } from "./preguntas/PreguntaSingleExportador";
import { PreguntaTextExportador } from "./preguntas/PreguntaTextExportador";
import { PreguntaVideoExportador } from "./preguntas/PreguntaVideoExportador";

export const providersExportador: Provider[] = [
    { provide: PreguntaExportadorToken, useClass: PreguntaDateSelectExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaDistributionExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaExtraPointsExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaFlowCheckpointExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaFlowGroupExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaFlowJumpExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaFlowRandomExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaInfoExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaMatrixMultipleExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaMatrixRangeExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaMatrixSingleExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaMultipleExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaNumericTextExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaRangeExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaRankingExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaSingleExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaTextExportador, multi: true },
    { provide: PreguntaExportadorToken, useClass: PreguntaVideoExportador, multi: true }
];
